import {
  getMockResponse,
  setMockResponse,
} from "@redotech/rpc-mock/mock-storage";

export function registerMerchantMockRpcResponses(): void {
  if (getMockResponse("checkActiveEscalation") === undefined) {
    setMockResponse("checkActiveEscalation", { activeEscalation: null });
  }
}
